<template>
  <div class="schedule-container">
    <div class="option-row">
      <div class="left">
        <span class="title">时间段:</span>
        <el-select
          v-model="time"
          v-scroll="handleScroll"
          value-key="id"
          class="input-query"
          placeholder="选择日期"
          filterable
          size="medium"
          @change="handleChangeTime"
        >
          <el-option
            v-for="(item,index) in dayList"
            :key="index"
            :label="item"
            :value="item"
          />
        </el-select>
        <div class="button pre" @click="changeWeek('pre')">
          <i class="el-icon-arrow-left"/>
        </div>
        <div class="button next" @click="changeWeek('next')">
          <i class="el-icon-arrow-right"/>
        </div>
      </div>
      <el-button class="right" @click="toggleEdit">{{ isEdit ? "退出编辑" : "编辑" }}</el-button>
    </div>
    <schedule :is-edit="isEdit" :select-week="time"/>
  </div>
</template>

<script>
import Schedule from "@views/SettingSchedule/Schedule";
import { getCurrentDate, getNextWeekTime, getFiveWeeksMondays } from "@utils/tools";

export default {
  name: "SettingSchedule",
  components: {
    Schedule
  },
  data() {
    return {
      time: "",
      dayList: [], // 时间列表
      isEdit: false,
      canClick: true, // 防抖函数, 滚动条能否继续滚动, 加载时间
    };
  },
  mounted() {
    const time = getCurrentDate();
    this.getFiveWeekFormat(time);
    this.time = this.dayList[0];
    // console.log(this.time);
  },
  methods: {
    /*
    * 将一个时间 2022-05-02 拿到前后五周, 并且转换到合适的时间段
    * 因为 getFiveWeeksMondays 函数会返回当周的, 所以要判断不保留
    * @param {Boolean} needThisWeek  会添加到下拉框 包括当周的
    * */
    getFiveWeekFormat(time, isFuture = true, needThisWeek = true) {
      const dotTime = time.split("-")[0];
      const weekList = getFiveWeeksMondays(dotTime, isFuture);
      if (!needThisWeek) {
        weekList.shift();
      }
      weekList.forEach(week => {
        const futureWeek = getNextWeekTime(week);
        if (isFuture) {
          this.dayList.push(futureWeek);
        } else {
          this.dayList.unshift(futureWeek);
        }
      });
    },
    // 选中新的时间了
    handleChangeTime(time) {
      // console.log(time);
    },
    /*
    * 防抖函数 滚动到底部了, 那么就生成更多日期的
    * */
    handleScroll() {
      if (this.canClick) {
        this.canClick = false;
        this.getFiveWeekFormat(this.dayList[this.dayList.length - 1], true, false);
        setTimeout(() => {
          this.canClick = true;
        }, 1000);
      }
    },
    /*
    * 更改每一周的数据
    * @param type { string }  pre 上一周 next 下一周
    * */
    async changeWeek(type) {
      let currentIndex = this.dayList.findIndex(item => {
        return item === this.time;
      });
      if (type === "pre") {
        if (currentIndex === 0) {
          // 第一个往前, 往前翻页
          await this.getFiveWeekFormat(this.dayList[0], false, false);
          currentIndex = this.dayList.findIndex(item => {
            return item === this.time;
          });
        }
        this.time = this.dayList[currentIndex - 1];
      } else {
        if (currentIndex === this.dayList.length - 1) {
          // 最后一页了
          this.getFiveWeekFormat(this.dayList[currentIndex], true, false);
        }
        this.time = this.dayList[currentIndex + 1];
      }
    },

    toggleEdit() {
      this.isEdit = !this.isEdit;
    }
  }
};
</script>

<style scoped lang="scss">
.schedule-container {
  background: #FBFBFB;
  border-radius: 10px;

  margin-top: 24px;
  padding: 24px;
}

.option-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;

  .left ::v-deep {
    display: flex;
    align-items: center;

    .title {
      display: inline-block;
      margin-right: 23px;
    }

    .input-query {
      width: 200px;
      color: #333333;
    }

    .el-date-editor.el-input, .el-date-editor.el-input__inner {
      width: 200px;
    }

    .el-input__inner {
      width: 200px;
      height: 32px;
      border: 1px solid #999999;
      border-radius: 10px;
      color: #333333;
    }

    .button {
      width: 32px;
      height: 32px;
      background: #FBFBFB;
      box-shadow: 0 0 4px 0 rgba(127, 147, 166, 0.4000);
      border-radius: 10px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .pre {
      margin-left: 32px;
    }
    .next {
      margin-left: 24px;
    }
  }

  .right.el-button {
    height: 32px;
    min-height: 32px;
    background: #2AA5E3;
    border-radius: 6px;
    color: #FBFBFB;
    padding-top: 8px;
  }
}


</style>
